export default "__VITE_ASSET__BXxHsJLK__"